var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.602 10a9.6 9.6 0 11-19.2 0 9.6 9.6 0 0119.2 0zm-9.6-7.2a.9.9 0 01.9.9v.38c.72.12 1.401.414 1.984.855.511.396.893.888 1.11 1.44a.9.9 0 01-1.674.66 1.62 1.62 0 00-.536-.676 2.623 2.623 0 00-.884-.435V9.16c.838.112 1.66.384 2.351.835.944.617 1.548 1.524 1.548 2.556s-.605 1.94-1.548 2.556c-.691.453-1.513.724-2.352.835v.36a.9.9 0 11-1.8 0v-.36c-.836-.111-1.658-.382-2.35-.835-.578-.378-1.028-.86-1.293-1.425a.9.9 0 111.63-.764c.097.208.295.452.649.683.375.246.847.424 1.365.519v-3.298a4.539 4.539 0 01-1.983-.856C6.282 9.32 5.802 8.417 5.802 7.45c0-.966.48-1.87 1.317-2.515a4.536 4.536 0 011.983-.856V3.7a.9.9 0 01.9-.9z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanking);
export default __webpack_public_path__ + "static/media/banking.196ffcbb9fa66f43db789cc9e8d80658.svg";
export { ForwardRef as ReactComponent };